export default __webpack_public_path__ + "static/media/BgGroup38237.e75d2a2d.png";